import React, { useState } from 'react';

interface LeaderboardPageProps {
  onBack: () => void;
}

const mockTopStreamers = [
  { id: 1, name: 'Alice_Star', username: '@alicestar', value: '124K', avatar: '🌸' },
  { id: 2, name: 'ProGamer_99', username: '@progamer', value: '98K', avatar: '🎮' },
  { id: 3, name: 'Melis_Live', username: '@meliss', value: '85K', avatar: '✨' },
  { id: 4, name: 'Canberk_dj', username: '@canberk', value: '72K', avatar: '🎧' },
  { id: 5, name: 'YigitOyunda', username: '@yigit', value: '64K', avatar: '🔥' },
  { id: 6, name: 'Zehra_vlog', username: '@zehrav', value: '55K', avatar: '📱' },
  { id: 7, name: 'DenizYildizi', username: '@deniz', value: '49K', avatar: '⭐' },
  { id: 8, name: 'KingKong', username: '@king', value: '41K', avatar: '🦍' },
  { id: 9, name: 'CagatayX', username: '@cagatayx', value: '38K', avatar: '😎' },
  { id: 10, name: 'Merve_beauty', username: '@merveb', value: '30K', avatar: '💄' },
];

const mockTopGifters = [
  { id: 1, name: 'Ahmet_Bey', username: '@ahmetb', value: '500K 💎', avatar: '👨' },
  { id: 2, name: 'Sponsor_X', username: '@sponsor', value: '420K 💎', avatar: '🎩' },
  { id: 3, name: 'Elif_Rich', username: '@elifr', value: '380K 💎', avatar: '👑' },
  { id: 4, name: 'Kartal_1903', username: '@kartal', value: '290K 💎', avatar: '🦅' },
  { id: 5, name: 'Aslan_Pasha', username: '@aslan', value: '250K 💎', avatar: '🦁' },
  { id: 6, name: 'Cemre_Su', username: '@cemres', value: '210K 💎', avatar: '💧' },
  { id: 7, name: 'Gizemliadam', username: '@gizemli', value: '180K 💎', avatar: '🕵️' },
  { id: 8, name: 'Baran_Baba', username: '@baran', value: '150K 💎', avatar: '🕶️' },
  { id: 9, name: 'Kral_Tr', username: '@kraltr', value: '120K 💎', avatar: '💯' },
  { id: 10, name: 'ZenginGenç', username: '@zenging', value: '98K 💎', avatar: '💸' },
];

const LeaderboardPage: React.FC<LeaderboardPageProps> = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState<'streamers' | 'gifters'>('streamers');

  const dataList = activeTab === 'streamers' ? mockTopStreamers : mockTopGifters;

  const getRankStyle = (index: number) => {
    switch (index) {
      case 0: return { color: '#FFD700', bg: 'rgba(255, 215, 0, 0.15)', border: '1px solid #FFD700', icon: '🥇' }; // Gold
      case 1: return { color: '#C0C0C0', bg: 'rgba(192, 192, 192, 0.12)', border: '1px solid #C0C0C0', icon: '🥈' }; // Silver
      case 2: return { color: '#CD7F32', bg: 'rgba(205, 127, 50, 0.12)', border: '1px solid #CD7F32', icon: '🥉' }; // Bronze
      default: return { color: 'var(--muted)', bg: 'rgba(255, 255, 255, 0.03)', border: '1px solid transparent', icon: `${index + 1}` };
    }
  };

  return (
    <div style={{
      width: '100%', height: '100%',
      background: 'linear-gradient(160deg, #12121c, #0e0e18)',
      display: 'flex', flexDirection: 'column',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '50px 20px 20px',
        background: 'rgba(255,255,255,.02)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', gap: 15,
        position: 'relative', zIndex: 10
      }}>
        <button onClick={onBack} className="icon-btn" style={{ background: 'rgba(255,255,255,.05)' }}>
          ←
        </button>
        <h2 className="syne" style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Liderlik Tablosu</h2>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', padding: '15px 20px', gap: 10 }}>
        <button
          onClick={() => setActiveTab('streamers')}
          style={{
            flex: 1, padding: '12px', borderRadius: 12,
            background: activeTab === 'streamers' ? 'rgba(255, 138, 61, 0.15)' : 'rgba(255,255,255,.03)',
            border: activeTab === 'streamers' ? '1px solid var(--coral)' : '1px solid transparent',
            color: activeTab === 'streamers' ? 'var(--coral)' : 'var(--muted)',
            fontWeight: 700, fontFamily: 'Syne', transition: 'all 0.2s', cursor: 'pointer'
          }}>
          🎬 En Çok İzlenen
        </button>
        <button
          onClick={() => setActiveTab('gifters')}
          style={{
            flex: 1, padding: '12px', borderRadius: 12,
            background: activeTab === 'gifters' ? 'rgba(0, 229, 204, 0.15)' : 'rgba(255,255,255,.03)',
            border: activeTab === 'gifters' ? '1px solid var(--cyan)' : '1px solid transparent',
            color: activeTab === 'gifters' ? 'var(--cyan)' : 'var(--muted)',
            fontWeight: 700, fontFamily: 'Syne', transition: 'all 0.2s', cursor: 'pointer'
          }}>
          💎 En Çok Hediye Alan
        </button>
      </div>

      {/* List */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px 90px', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {dataList.map((user, index) => {
          const rank = getRankStyle(index);
          const isTop3 = index < 3;

          return (
            <div key={user.id} style={{
              display: 'flex', alignItems: 'center', gap: 12,
              background: rank.bg,
              border: rank.border,
              borderRadius: 16, padding: '12px 16px',
              position: 'relative', overflow: 'hidden'
            }}>
              {/* Rank Column */}
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: index >= 3 ? 'rgba(255,255,255,0.05)' : 'transparent',
                fontSize: isTop3 ? 24 : 14, fontWeight: 700,
                color: isTop3 ? '#fff' : 'var(--muted)'
              }}>
                {rank.icon}
              </div>

              {/* Avatar Column */}
              <div style={{
                width: 44, height: 44, borderRadius: 14,
                background: 'linear-gradient(135deg, var(--purple), var(--coral))',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, flexShrink: 0
              }}>
                {user.avatar}
              </div>

              {/* User Info Column */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="syne" style={{ fontSize: 15, fontWeight: index === 0 ? 800 : 700, color: index === 0 ? rank.color : '#fff', marginBottom: 2 }}>
                  {user.name}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                  {user.username}
                </div>
              </div>

              {/* Score Column */}
              <div style={{
                fontSize: 15, fontWeight: 800, fontFamily: 'Syne',
                color: activeTab === 'streamers' ? 'var(--coral)' : 'var(--cyan)'
              }}>
                {user.value}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeaderboardPage;
